import { MASTER_DATA_ENTITIES } from '../../lib/masterDataConfig.js';
import { ModuleLayout, type ModuleTab } from './ModuleLayout.js';
import { useVisibleTabs } from '../useNavAccess.js';

export const MASTER_DATA_TABS: readonly ModuleTab[] = [
  { id: 'overview', hrefSuffix: '', label: 'نمای کلی' },
  ...MASTER_DATA_ENTITIES.map((entity): ModuleTab => ({
    id: entity.kind,
    hrefSuffix: `/${entity.pathSegment}`,
    label: entity.labelPlural,
  })),
  { id: 'brand-assets', hrefSuffix: '/brand-assets', label: 'مهر و امضا' },
];

/**
 * Persistent module header + tab strip for Master Data — the shared v2
 * `ModuleLayout` (module mark, title, V2Tabs), same as every other module.
 * The Hub page's entity-card grid stays as the "overview" tab's content; the
 * tabs add a stable way to jump straight to one entity from any of its
 * subpages without losing the «اطلاعات پایه» context.
 */
export function MasterDataModuleLayout() {
  const tabs = useVisibleTabs('master-data', MASTER_DATA_TABS);
  return (
    <ModuleLayout
      moduleId="master-data"
      title="اطلاعات پایه"
      subtitle="داده‌های مشترک همهٔ ماژول‌ها"
      tabs={tabs}
    />
  );
}
